import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-[#182C4B] sm:pt-6 lg:pt-10"
}
const _hoisted_2 = { class: "p-4 md:flex" }
const _hoisted_3 = { class: "mx-auto mt-6 grid w-full max-w-7xl grid-cols-3 justify-around gap-x-5 text-white" }
const _hoisted_4 = { class: "text-base font-bold md:text-2xl" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex flex-col items-center justify-center p-4 text-center md:flex-row" }
const _hoisted_7 = { class: "px-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mt-6 p-2" }
const _hoisted_10 = { class: "text-sm text-white sm:text-base" }

import {
  computed,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import DevelopedByWithLogo from '@/components/App/DevelopedByWithLogo.vue';
import {
  CONFIG,
  CONSTANTS,
} from '@/helpers';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterSection',
  props: {
  isDevelopedByShown: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const authStore = useStore.auth;
const router = useRouter();

const user = computed(() => authStore.user);

const currentYear = new Date().getFullYear();

const siteSections = [
  {
    title: 'About',
    items: [
      {
        name: 'About Us', path: 'https://nerddevs.com/',
      },
      {
        name: 'Contact Us', path: '#contact-us',
      },
      {
        name: 'Terms & Conditions', path: '/terms.html',
      },
    ],
  },
  {
    title: 'Support',
    items: [
      {
        name: 'Features', path: '#features',
      },
      {
        name: 'How to Use', path: 'https://www.youtube.com/watch?v=C9WPo5xDTSA',
      },
      {
        name: 'Privacy Policy', path: '/privacy-policy.html',
      },
      {
        name: 'Refund Policy', path: '/refund-policy',
      },
    ],
  },
  {
    title: 'Company',
    items: [
      {
        name: 'Pricing', path: '#pricing',
      },
      {
        name: 'FAQs', path: '/faq',
      },
    ],
  },
];

function onItemClick(path: string): void {
  if (path.startsWith('http')) {
    window.open(path, '_blank');
    return;
  }

  if (path.startsWith('#')) {
    router.push({
      path: '/', hash: path,
    });
    return;
  }

  router.push(path);
}


return (_ctx: any,_cache: any) => {
  return (_unref(router).currentRoute.value.path != _unref(CONSTANTS).ROUTES.MEMBER_HOME && !user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(siteSections, (section) => {
              return _createElementVNode("div", {
                key: section.title,
                class: "mx-auto"
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(section.title), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.name,
                      class: "py-1 text-xs font-normal md:text-base"
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-start hover:underline",
                        onClick: ($event: any) => (onItemClick(item.path))
                      }, _toDisplayString(item.name), 9, _hoisted_5)
                    ]))
                  }), 128))
                ])
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "mt-11 h-12 sm:h-14 md:mt-6 lg:h-18",
              src: require('@/assets/landing-page/footer-ai-mate-logo.svg'),
              alt: "footer ai mate logo"
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, " Copyright © " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_unref(CONFIG).appName) + ", all rights reserved ", 1),
            (__props.isDevelopedByShown)
              ? (_openBlock(), _createBlock(DevelopedByWithLogo, {
                  key: 0,
                  class: "pt-2 text-white"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})